import { AccountOrderHistory } from "@app/account/account.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const orderHistoryAdapter: EntityAdapter<AccountOrderHistory> = createEntityAdapter<AccountOrderHistory>({
	selectId: item => item.accountId,
});